export enum RouteEnum {
  ROOT = '',
  MAIN = '/',
  ADD = 'new',
  AUTH = 'auth',
  REGISTER = 'register',
  ONBOARDING = 'onboarding',
  PROJECTS = '/projects',
  USERS = '/users',
  OBJECTS = '/objects',
  ROLES = '/roles',
  TASKS = '/tasks',
  WORKSPACE = '/workspace',
  SETTINGS = '/settings',
  MILESTONES = 'milestones',
  MILESTONE_TRANSFER = 'milestones-transfer',
  MILESTONE_SEQ = 'milestones-sequence',
  CONFIRM_EMAIL = '',
}
